export const PLAN_STATUSES = ['draft', 'active', 'inactive', 'archived'];

export function planStatusLabel(s) {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}
